import axios from "axios";
import {
  SETTINGS_CONNECTION_STATUS_ERROR,
  SETTINGS_DELETE_CONNECTION_STATUS_SUCCESS,
  SETTINGS_GET_CONNECTION_STATUS_LOADING,
  SETTINGS_ADD_CONNECTION_STATUS_ERROR,
  SETTINGS_ADD_CONNECTION_STATUS_SUCCESS,
  SETTINGS_ADD_CONNECTION_STATUS,
  SETTINGS_GET_CONNECTION_STATUS,
  SETTINGS_CONNECTION_STATUS_CLEAR_SNACKBAR,
} from "../constants/types";
import queryString from "query-string";

// import { bulkUploadFiles } from "./documentsActions";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchConnectionStatus = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_CONNECTION_STATUS_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/ConnectionStatus`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_CONNECTION_STATUS,
            payload: {
              statusName: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_CONNECTION_STATUS_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all ConnectionStatus.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdateConnectionStatus = ({ formData, onSuccess, payload }) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_CONNECTION_STATUS,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.connectionStatusId ? "PUT" : "POST",
        url: `${server_url}/ConnectionStatus${
          formData.connectionStatusId ? `/${formData.connectionStatusId}` : ""
        }`,
        body: { ...data, listingOrder: data.listingOrder + 1 },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_CONNECTION_STATUS_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.connectionStatusId
                ? "ConnectionStatus updated Successfully"
                : "ConnectionStatus Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_CONNECTION_STATUS_ERROR,
            payload: {
              text: "Error occurred during creating connectionStatus data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const connectionStatusDelete = ({
    connectionStatusId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the connectionStatusDelete Action", connectionStatusId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_CONNECTION_STATUS_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/ConnectionStatus/${connectionStatusId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchConnectionStatus({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_CONNECTION_STATUS_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "connectionStatus Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_CONNECTION_STATUS_ERROR,
            payload: {
              text: "Error occurred during deleting connectionStatus data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const connectionStatusClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_CONNECTION_STATUS_CLEAR_SNACKBAR,
    });
  };
};
